export const PLANNER_MODAL = 'PLANNER_MODAL';
export const LAZY_LOAD_ITEMS = 'LAZY_LOAD_ITEMS';
